















import { Component, Prop, Vue } from 'vue-property-decorator';
import { getMonthName } from '@/utils/date-helpers';

@Component
export default class CalendarMonthPicker extends Vue {
  @Prop() private date!: Date;

  get currentMonthName() {
    return getMonthName(this.date.getMonth());
  }

  get isNotCurrentMonth() {
    return this.date.getMonth() !== new Date(Date.now()).getMonth();
  }
}
